import types from '../../types';

const wallets = (
  state = { loading: true, margin: null, history: null, historyFiat: null },
  { type, payload },
) => {
  switch (type) {
    case types.GET_EXCHANGE_BALANCE_SUCCESS:
      return { ...state, ...payload, loading: false };

    case types.GET_MARGIN_BALANCE_SUCCESS:
      return { ...state, margin: payload, loading: false };

    case types.GET_TRANSACTIONS_HISTORY_SUCCESS:
      return { ...state, history: payload, loading: false };

    case types.GET_TRANSACTIONS_HISTORY_FIAT_SUCCESS:
      return { ...state, historyFiat: payload, loading: false };

    case types.GET_EXCHANGE_BALANCE_START:
    case types.GET_TRANSACTIONS_HISTORY_START:
    case types.GET_TRANSACTIONS_HISTORY_FIAT_START:
    case types.GET_MARGIN_BALANCE_START:
      return { ...state, loading: true };

    case types.GET_EXCHANGE_BALANCE_FAILURE:
    case types.GET_MARGIN_BALANCE_FAILURE:
    case types.GET_TRANSACTIONS_HISTORY_FAILURE:
    case types.GET_TRANSACTIONS_HISTORY_FIAT_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default wallets;
